import React from 'react';
import SignHeader from '../components/FlowComponents/SignHeader/SignHeader';
import SignFooter from '../components/FlowComponents/SignFooter/SignFooter';
import PackageListView from '../components/LmsView/PackageListView';

function CoursePage() {
    return (
        <>
            <PackageListView />
        </>
    );
}

export default CoursePage;